import React from "react";

const OverviewIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_320_31600)">
        <path
          d="M6.93745 0H1.31245C0.58873 0 0 0.58873 0 1.31245V4.68745C0 5.41132 0.58873 6.00005 1.31245 6.00005H6.93745C7.66132 6.00005 8.25005 5.41132 8.25005 4.68745V1.31245C8.25005 0.58873 7.66132 0 6.93745 0Z"
          fill="#FFCFBB"
        />
        <path
          d="M6.93745 7.5H1.31245C0.58873 7.5 0 8.08873 0 8.81259V16.6876C0 17.4113 0.58873 18 1.31245 18H6.93745C7.66132 18 8.25005 17.4113 8.25005 16.6876V8.81259C8.25005 8.08873 7.66132 7.5 6.93745 7.5Z"
          fill="#FFCFBB"
        />
        <path
          d="M16.6876 12H11.0626C10.3387 12 9.75 12.5887 9.75 13.3126V16.6876C9.75 17.4113 10.3387 18 11.0626 18H16.6876C17.4113 18 18 17.4113 18 16.6876V13.3126C18 12.5887 17.4113 12 16.6876 12Z"
          fill="#FFCFBB"
        />
        <path
          d="M16.6876 0H11.0626C10.3387 0 9.75 0.58873 9.75 1.31245V9.18745C9.75 9.91132 10.3387 10.5 11.0626 10.5H16.6876C17.4113 10.5 18 9.91132 18 9.18745V1.31245C18 0.58873 17.4113 0 16.6876 0V0Z"
          fill="#FFCFBB"
        />
      </g>
      <defs>
        <clipPath id="clip0_320_31600">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const UsersIcon = () => {
  return (
    <svg
      width="21"
      height="18"
      viewBox="0 0 21 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.315 7.01082C12.251 7.01082 13.8204 5.4414 13.8204 3.50541C13.8204 1.56943 12.251 0 10.315 0C8.379 0 6.80957 1.56943 6.80957 3.50541C6.80957 5.4414 8.379 7.01082 10.315 7.01082Z"
        fill="#FFCFBB"
      />
      <path
        d="M17.406 7.01025C18.6299 7.01025 19.6221 6.01809 19.6221 4.79419C19.6221 3.57029 18.6299 2.57812 17.406 2.57812C16.1821 2.57812 15.1899 3.57029 15.1899 4.79419C15.1899 6.01809 16.1821 7.01025 17.406 7.01025Z"
        fill="#FFCFBB"
      />
      <path
        d="M3.22339 7.01025C4.44729 7.01025 5.43945 6.01809 5.43945 4.79419C5.43945 3.57029 4.44729 2.57812 3.22339 2.57812C1.99949 2.57812 1.00732 3.57029 1.00732 4.79419C1.00732 6.01809 1.99949 7.01025 3.22339 7.01025Z"
        fill="#FFCFBB"
      />
      <path
        d="M5.40679 9.00119C4.53447 8.28649 3.74446 8.3811 2.73583 8.3811C1.2273 8.3811 0 9.60114 0 11.1004V15.5007C0 16.1518 0.531452 16.6813 1.18499 16.6813C4.00648 16.6813 3.66658 16.7323 3.66658 16.5596C3.66658 13.4415 3.29726 11.1549 5.40679 9.00119Z"
        fill="#FFCFBB"
      />
      <path
        d="M11.2739 8.39715C9.51219 8.25021 7.98089 8.39885 6.66008 9.48907C4.44978 11.2595 4.87514 13.6433 4.87514 16.5595C4.87514 17.3311 5.50289 17.9705 6.28617 17.9705C14.7911 17.9705 15.1296 18.2449 15.6339 17.128C15.7993 16.7503 15.754 16.8704 15.754 13.2572C15.754 10.3873 13.2691 8.39715 11.2739 8.39715Z"
        fill="#FFCFBB"
      />
      <path
        d="M17.8936 8.381C16.8795 8.381 16.0938 8.28736 15.2227 9.00109C17.3164 11.1388 16.9629 13.2694 16.9629 16.5595C16.9629 16.7333 16.6807 16.6812 19.4022 16.6812C20.0791 16.6812 20.6294 16.1328 20.6294 15.4587V11.1003C20.6294 9.60104 19.4022 8.381 17.8936 8.381Z"
        fill="#FFCFBB"
      />
    </svg>
  );
};

const TransactionsIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_320_31617)">
        <path
          d="M3.92475 9.59619L0.17475 6.0337C0.063 5.9272 0 5.7802 0 5.6257C0 5.4712 0.063 5.3242 0.17475 5.2177L3.92475 1.65521C4.28475 1.31471 4.875 1.57196 4.875 2.06321V3.7507H11.8125C12.3293 3.7507 12.75 4.17145 12.75 4.6882V6.5632C12.75 7.07995 12.3293 7.5007 11.8125 7.5007H4.875V9.18819C4.875 9.68319 4.281 9.93369 3.92475 9.59619Z"
          fill="#FFCFBB"
        />
        <path
          d="M12.75 5.625H0C0 5.7795 0.063 5.9265 0.17475 6.033L3.92475 9.59549C4.038 9.70199 4.1745 9.74999 4.308 9.74999C4.5975 9.74999 4.875 9.52574 4.875 9.18749V7.5H11.8125C12.3293 7.5 12.75 7.07925 12.75 6.5625V5.625Z"
          fill="#FFCFBB"
        />
        <path
          d="M13.125 15.9377V14.2502H6.1875C5.67075 14.2502 5.25 13.8294 5.25 13.3127V11.4377C5.25 10.9209 5.67075 10.5002 6.1875 10.5002H13.125V8.81267C13.125 8.31917 13.7183 8.06642 14.0753 8.40467L17.8253 11.9672C17.937 12.0737 18 12.2207 18 12.3752C18 12.5297 17.937 12.6767 17.8253 12.7832L14.0753 16.3457C13.7183 16.6839 13.125 16.4319 13.125 15.9377Z"
          fill="#FFCFBB"
        />
        <path
          d="M18 12.375H5.25V13.3125C5.25 13.8292 5.67075 14.25 6.1875 14.25H13.125V15.9375C13.125 16.2757 13.4025 16.5 13.692 16.5C13.8255 16.5 13.962 16.452 14.0745 16.3455L17.8245 12.783C17.937 12.6765 18 12.5295 18 12.375Z"
          fill="#FFCFBB"
        />
      </g>
      <defs>
        <clipPath id="clip0_320_31617">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const SettingsIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.7599 8.62361C12.7839 8.42361 12.7999 8.21561 12.7999 7.99961C12.7999 7.78361 12.7839 7.57561 12.7519 7.37561L14.1039 6.31961C14.2239 6.22361 14.2559 6.04761 14.1839 5.91161L12.9039 3.69561C12.8239 3.55161 12.6559 3.50361 12.5119 3.55161L10.9199 4.19161C10.5839 3.93561 10.2319 3.72761 9.83991 3.56761L9.59991 1.87161C9.57591 1.71161 9.43991 1.59961 9.27991 1.59961H6.71991C6.55991 1.59961 6.43191 1.71161 6.40791 1.87161L6.16791 3.56761C5.77591 3.72761 5.41591 3.94361 5.08791 4.19161L3.49591 3.55161C3.35191 3.49561 3.18391 3.55161 3.10391 3.69561L1.82391 5.91161C1.74391 6.05561 1.77591 6.22361 1.90391 6.31961L3.25591 7.37561C3.22391 7.57561 3.19991 7.79161 3.19991 7.99961C3.19991 8.20761 3.21591 8.42361 3.24791 8.62361L1.89591 9.67961C1.77591 9.77561 1.74391 9.95161 1.81591 10.0876L3.09591 12.3036C3.17591 12.4476 3.34391 12.4956 3.48791 12.4476L5.07991 11.8076C5.41591 12.0636 5.76791 12.2716 6.15991 12.4316L6.39991 14.1276C6.43191 14.2876 6.55991 14.3996 6.71991 14.3996H9.27991C9.43991 14.3996 9.57591 14.2876 9.59191 14.1276L9.83191 12.4316C10.2239 12.2716 10.5839 12.0556 10.9119 11.8076L12.5039 12.4476C12.6479 12.5036 12.8159 12.4476 12.8959 12.3036L14.1759 10.0876C14.2559 9.94361 14.2239 9.77561 14.0959 9.67961L12.7599 8.62361ZM7.99991 10.3996C6.67991 10.3996 5.59991 9.31961 5.59991 7.99961C5.59991 6.67961 6.67991 5.59961 7.99991 5.59961C9.31991 5.59961 10.3999 6.67961 10.3999 7.99961C10.3999 9.31961 9.31991 10.3996 7.99991 10.3996Z"
        fill="#FFCFBB"
      />
    </svg>
  );
};

const LogsIcon = () => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.0756 2.82384C17.9736 2.65333 17.8055 2.53378 17.6115 2.49476L7.31755 0.0130795C6.97829 -0.0526853 6.64359 0.134726 6.52617 0.458884L2.6024 10.427L3.91233 10.9044L7.63079 1.42629L16.5751 3.70869C16.0165 5.4404 14.6872 9.05481 13.4131 12.4202C12.3022 15.3565 11.6629 16.362 10.448 16.5674C10.4465 16.5659 10.4452 16.5645 10.4452 16.5624C7.96208 16.9105 8.00665 13.7449 8.00665 13.7449L0.0762616 10.5415C-0.487295 14.1135 2.25741 14.9726 2.25741 14.9726L8.06356 17.6087C8.06495 17.6094 8.97133 18.0412 9.95644 17.9968C12.6136 17.9342 13.5474 16.0048 14.7174 12.9137C16.4077 8.44636 18.1234 3.44075 18.1403 3.38766C18.2007 3.19826 18.1769 2.99399 18.0756 2.82384Z"
        fill="#FFCFBB"
      />
      <path
        d="M13.3836 6.84318C13.4441 6.85972 13.5067 6.8685 13.5685 6.8685C13.8743 6.8685 14.1542 6.66459 14.2399 6.3552C14.3418 5.98358 14.1217 5.59968 13.7506 5.49842L10.7294 4.56592C10.3624 4.46434 9.9742 4.68265 9.87294 5.05391C9.77165 5.4255 9.9897 5.80943 10.3622 5.91105L13.3836 6.84318Z"
        fill="#FFCFBB"
      />
      <path
        d="M8.66268 7.8464C8.54159 8.21241 8.73818 8.60656 9.10316 8.72872L12.1086 9.8027C12.1815 9.82699 12.2533 9.8379 12.3256 9.8383C12.6187 9.83985 12.8933 9.65493 12.9912 9.36215C13.1126 8.99714 12.9164 8.6024 12.55 8.48032L9.54569 7.40703C9.17855 7.28553 8.78521 7.48209 8.66268 7.8464Z"
        fill="#FFCFBB"
      />
      <path
        d="M8.39831 10.3173C8.03267 10.1949 7.63786 10.3946 7.51831 10.7617C7.39809 11.1259 7.59847 11.5211 7.96411 11.6406L10.9758 12.7101C11.0484 12.7347 11.1206 12.7453 11.1939 12.7453C11.4864 12.7453 11.7592 12.559 11.8556 12.2664C11.9758 11.9001 11.7761 11.5056 11.4105 11.3861L8.39831 10.3173Z"
        fill="#FFCFBB"
      />
      <path
        d="M8.28664 3.75391C8.71345 3.75391 9.05976 4.0907 9.05976 4.50557C9.05976 4.92077 8.71345 5.2572 8.28664 5.2572C7.8595 5.2572 7.51318 4.92073 7.51318 4.50557C7.51322 4.0907 7.8595 3.75391 8.28664 3.75391Z"
        fill="#FFCFBB"
      />
      <path
        d="M7.19289 6.54688C7.62006 6.54688 7.96601 6.88334 7.96601 7.29817C7.96601 7.71267 7.62006 8.0491 7.19289 8.0491C6.76575 8.0491 6.41943 7.71267 6.41943 7.29817C6.41943 6.88338 6.76575 6.54688 7.19289 6.54688Z"
        fill="#FFCFBB"
      />
      <path
        d="M6.02638 9.42969C6.45356 9.42969 6.79983 9.76652 6.79983 10.1821C6.79983 10.5969 6.45356 10.933 6.02638 10.933C5.59924 10.933 5.25293 10.597 5.25293 10.1821C5.25293 9.76652 5.59924 9.42969 6.02638 9.42969Z"
        fill="#FFCFBB"
      />
    </svg>
  );
};

const QrCodeIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_320_31641)">
        <path
          d="M17.2502 6.522C16.8355 6.522 16.5002 6.186 16.5002 5.772V2.217C16.5002 1.82175 16.1785 1.5 15.784 1.5H12.229C11.8143 1.5 11.479 1.164 11.479 0.75C11.479 0.336 11.8143 0 12.229 0H15.784C17.0065 0 18.0002 0.9945 18.0002 2.217V5.772C18.0002 6.186 17.665 6.522 17.2502 6.522Z"
          fill="#FFCFBB"
        />
        <path
          d="M0.75 6.522C0.33525 6.522 0 6.186 0 5.772V2.217C0 0.9945 0.99375 0 2.21625 0H5.77125C6.186 0 6.52125 0.336 6.52125 0.75C6.52125 1.164 6.186 1.5 5.77125 1.5H2.21625C1.82175 1.5 1.5 1.82175 1.5 2.217V5.772C1.5 6.186 1.16475 6.522 0.75 6.522Z"
          fill="#FFCFBB"
        />
        <path
          d="M15.784 18.0005H12.229C11.8143 18.0005 11.479 17.6645 11.479 17.2505C11.479 16.8365 11.8143 16.5005 12.229 16.5005H15.784C16.1785 16.5005 16.5002 16.1788 16.5002 15.7835V12.2285C16.5002 11.8145 16.8355 11.4785 17.2502 11.4785C17.665 11.4785 18.0002 11.8145 18.0002 12.2285V15.7835C18.0002 17.006 17.0065 18.0005 15.784 18.0005Z"
          fill="#FFCFBB"
        />
        <path
          d="M5.77125 18.0005H2.21625C0.99375 18.0005 0 17.006 0 15.7835V12.2285C0 11.8145 0.33525 11.4785 0.75 11.4785C1.16475 11.4785 1.5 11.8145 1.5 12.2285V15.7835C1.5 16.1788 1.82175 16.5005 2.21625 16.5005H5.77125C6.186 16.5005 6.52125 16.8365 6.52125 17.2505C6.52125 17.6645 6.186 18.0005 5.77125 18.0005Z"
          fill="#FFCFBB"
        />
        <path
          d="M7.1085 8.36925H3.375C2.96025 8.36925 2.625 8.03325 2.625 7.61925V3.375C2.625 2.961 2.96025 2.625 3.375 2.625H7.1085C7.52325 2.625 7.8585 2.961 7.8585 3.375V7.61925C7.8585 8.03325 7.5225 8.36925 7.1085 8.36925ZM4.125 6.86925H6.3585V4.125H4.125V6.86925Z"
          fill="#FFCFBB"
        />
        <path
          d="M14.625 15.375H11.0625C10.6478 15.375 10.3125 15.039 10.3125 14.625V12.2385C10.3125 11.8245 10.6478 11.4885 11.0625 11.4885C11.4772 11.4885 11.8125 11.8245 11.8125 12.2385V13.875H13.875V11.625H12.9885C12.5738 11.625 12.2385 11.289 12.2385 10.875C12.2385 10.461 12.5738 10.125 12.9885 10.125H14.625C15.0398 10.125 15.375 10.461 15.375 10.875V14.625C15.375 15.039 15.0398 15.375 14.625 15.375Z"
          fill="#FFCFBB"
        />
        <path
          d="M14.6249 7.19325H11.5566C11.1419 7.19325 10.8066 6.85725 10.8066 6.44325V3.375C10.8066 2.961 11.1419 2.625 11.5566 2.625H14.6249C15.0396 2.625 15.3749 2.961 15.3749 3.375V6.44325C15.3749 6.85725 15.0396 7.19325 14.6249 7.19325ZM12.3066 5.69325H13.8749V4.125H12.3066V5.69325Z"
          fill="#FFCFBB"
        />
        <path
          d="M9.35849 10.6019H3.375C2.96025 10.6019 2.625 10.2659 2.625 9.85188C2.625 9.43788 2.96025 9.10188 3.375 9.10188H8.60849V4.05664C8.60849 3.64264 8.94374 3.30664 9.35849 3.30664C9.77324 3.30664 10.1085 3.64264 10.1085 4.05664V9.85188C10.1085 10.2659 9.77249 10.6019 9.35849 10.6019Z"
          fill="#FFCFBB"
        />
        <path
          d="M11.4375 10.4148C11.0227 10.4148 10.6875 10.0788 10.6875 9.66482V8.64257C10.6875 8.22858 11.0227 7.89258 11.4375 7.89258H14.8125C15.2272 7.89258 15.5625 8.22858 15.5625 8.64257C15.5625 9.05657 15.2272 9.39257 14.8125 9.39257H12.1875V9.66482C12.1875 10.0788 11.8522 10.4148 11.4375 10.4148Z"
          fill="#FFCFBB"
        />
        <path
          d="M9.01661 14.4013C8.60185 14.4013 8.2666 14.0653 8.2666 13.6513V11.9473C8.2666 11.5333 8.60185 11.1973 9.01661 11.1973C9.43136 11.1973 9.76661 11.5333 9.76661 11.9473V13.6513C9.76661 14.0653 9.43136 14.4013 9.01661 14.4013Z"
          fill="#FFCFBB"
        />
        <path
          d="M6.9375 15.3735H3.375C2.96025 15.3735 2.625 15.0375 2.625 14.6235V11.8965C2.625 11.4825 2.96025 11.1465 3.375 11.1465H6.9375C7.35225 11.1465 7.6875 11.4825 7.6875 11.8965V14.6235C7.6875 15.0375 7.35225 15.3735 6.9375 15.3735ZM4.125 13.8735H6.1875V12.6465H4.125V13.8735Z"
          fill="#FFCFBB"
        />
      </g>
      <defs>
        <clipPath id="clip0_320_31641">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const OtpIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.95828 13.6978C2.88803 13.5758 2.72903 13.5351 2.60701 13.6054L1.96362 13.9788V13.2356C1.96362 13.0951 1.849 12.9805 1.70849 12.9805C1.56798 12.9805 1.45335 13.0951 1.45335 13.2356V13.9788L0.809965 13.6054C0.687944 13.5351 0.528947 13.5758 0.458692 13.6978C0.388437 13.8198 0.429111 13.9788 0.551132 14.0491L1.19822 14.4262L0.551132 14.8034C0.429111 14.8736 0.388437 15.0326 0.458692 15.1547C0.528947 15.2767 0.687944 15.3174 0.809965 15.2471L1.45335 14.8736V15.6169C1.45335 15.7574 1.56798 15.872 1.70849 15.872C1.849 15.872 1.96362 15.7574 1.96362 15.6169V14.8736L2.60701 15.2471C2.72903 15.3174 2.88803 15.2767 2.95828 15.1547C3.02854 15.0326 2.98786 14.8736 2.86584 14.8034L2.21876 14.4262L2.86584 14.0491C2.98786 13.9751 3.03223 13.8198 2.95828 13.6978Z"
        fill="#FFCFBB"
      />
      <path
        d="M5.321 15.1508C5.39125 15.2728 5.55025 15.3135 5.67227 15.2432L6.31566 14.8697V15.613C6.31566 15.7535 6.43028 15.8681 6.57079 15.8681C6.7113 15.8681 6.82593 15.7535 6.82593 15.613V14.8697L7.46931 15.2432C7.59133 15.3135 7.75033 15.2728 7.82059 15.1508C7.89084 15.0287 7.85017 14.8697 7.72815 14.7995L7.08106 14.4223L7.72815 14.0452C7.85017 13.9749 7.89084 13.8159 7.82059 13.6939C7.75033 13.5719 7.59133 13.5312 7.46931 13.6015L6.82593 13.9749V13.2317C6.82593 13.0912 6.7113 12.9766 6.57079 12.9766C6.43028 12.9766 6.31566 13.0912 6.31566 13.2317V13.9749L5.67227 13.6052C5.55025 13.5349 5.39125 13.5756 5.321 13.6976C5.25074 13.8196 5.29142 13.9786 5.41344 14.0489L6.06052 14.426L5.41344 14.7995C5.29142 14.8697 5.25074 15.0287 5.321 15.1508Z"
        fill="#FFCFBB"
      />
      <path
        d="M4.8623 17.0886V17.5397C4.8623 17.6469 4.95105 17.7356 5.05828 17.7356H8.08663C8.19386 17.7356 8.2826 17.6469 8.2826 17.5397V17.0886C8.2826 16.9813 8.19386 16.8926 8.08663 16.8926H5.05828C4.94735 16.8926 4.8623 16.9813 4.8623 17.0886Z"
        fill="#FFCFBB"
      />
      <path
        d="M12.2427 4.4796H12.2205V3.47385C12.2205 1.72487 10.7895 0.238431 9.04427 0.268012C7.34706 0.297593 5.97155 1.6879 5.97155 3.3925V3.48864C5.97155 3.63284 6.08988 3.75117 6.23408 3.75117H7.07344C7.21765 3.75117 7.33597 3.63284 7.33597 3.48864V3.45906C7.33597 2.51986 8.04221 1.69529 8.98141 1.63613C10.0019 1.57327 10.8524 2.38305 10.8524 3.3888V4.4759H8.26407V4.4796H5.87172C5.428 4.49439 5.06934 4.85306 5.06934 5.30047V9.84854C5.06934 10.3033 5.4391 10.6731 5.8939 10.6731H12.239C12.6938 10.6731 13.0636 10.3033 13.0636 9.84854V5.30417C13.0673 4.84936 12.6975 4.4796 12.2427 4.4796ZM9.55823 7.78157C9.49537 7.82594 9.47689 7.87401 9.47689 7.94796C9.48058 8.28075 9.48058 8.61353 9.47689 8.95002C9.48428 9.09053 9.41403 9.22364 9.28831 9.2865C8.9962 9.43441 8.70409 9.22734 8.70409 8.95002C8.70409 8.95002 8.70409 8.95002 8.70409 8.94632C8.70409 8.61353 8.70409 8.27705 8.70409 7.94427C8.70409 7.87771 8.6893 7.82964 8.63013 7.78527C8.32693 7.56341 8.22709 7.18256 8.3787 6.84607C8.5266 6.52068 8.88527 6.32841 9.22175 6.39866C9.59891 6.47261 9.86144 6.77952 9.86514 7.15298C9.87623 7.41551 9.769 7.62997 9.55823 7.78157Z"
        fill="#FFCFBB"
      />
      <path
        d="M9.72119 17.0886V17.5397C9.72119 17.6469 9.80993 17.7356 9.91717 17.7356H12.9455C13.0527 17.7356 13.1415 17.6469 13.1415 17.5397V17.0886C13.1415 16.9813 13.0527 16.8926 12.9455 16.8926H9.91717C9.80993 16.8926 9.72119 16.9813 9.72119 17.0886Z"
        fill="#FFCFBB"
      />
      <path
        d="M10.1794 15.1508C10.2497 15.2728 10.4086 15.3135 10.5307 15.2432L11.1741 14.8697V15.613C11.1741 15.7535 11.2887 15.8681 11.4292 15.8681C11.5697 15.8681 11.6843 15.7535 11.6843 15.613V14.8697L12.3277 15.2432C12.4497 15.3135 12.6087 15.2728 12.679 15.1508C12.7493 15.0287 12.7086 14.8697 12.5866 14.7995L11.9395 14.4223L12.5866 14.0452C12.7086 13.9749 12.7493 13.8159 12.679 13.6939C12.6087 13.5719 12.4497 13.5312 12.3277 13.6015L11.6843 13.9749V13.2317C11.6843 13.0912 11.5697 12.9766 11.4292 12.9766C11.2887 12.9766 11.1741 13.0912 11.1741 13.2317V13.9749L10.5307 13.6015C10.4086 13.5312 10.2497 13.5719 10.1794 13.6939C10.1091 13.8159 10.1498 13.9749 10.2718 14.0452L10.9189 14.4223L10.2718 14.7995C10.1498 14.8697 10.1091 15.0287 10.1794 15.1508Z"
        fill="#FFCFBB"
      />
      <path
        d="M17.8039 16.8926H14.7756C14.6683 16.8926 14.5796 16.9813 14.5796 17.0886V17.5397C14.5796 17.6469 14.6683 17.7356 14.7756 17.7356H17.8039C17.9111 17.7356 17.9999 17.6469 17.9999 17.5397V17.0886C17.9999 16.9813 17.9111 16.8926 17.8039 16.8926Z"
        fill="#FFCFBB"
      />
      <path
        d="M0.195974 17.7356H3.22432C3.33155 17.7356 3.4203 17.6469 3.4203 17.5397V17.0886C3.4203 16.9813 3.33155 16.8926 3.22432 16.8926H0.195974C0.0887428 16.8926 0 16.9813 0 17.0886V17.5397C0 17.6469 0.0887428 17.7356 0.195974 17.7356Z"
        fill="#FFCFBB"
      />
      <path
        d="M15.0419 15.1508C15.1121 15.2728 15.2711 15.3135 15.3932 15.2432L16.0365 14.8697V15.613C16.0365 15.7535 16.1512 15.8681 16.2917 15.8681C16.4322 15.8681 16.5468 15.7535 16.5468 15.613V14.8697L17.1902 15.2432C17.3122 15.3135 17.4712 15.2728 17.5415 15.1508C17.6117 15.0287 17.571 14.8697 17.449 14.7995L16.8019 14.4223L17.449 14.0452C17.571 13.9749 17.6117 13.8159 17.5415 13.6939C17.4712 13.5719 17.3122 13.5312 17.1902 13.6015L16.5468 13.9749V13.2317C16.5468 13.0912 16.4322 12.9766 16.2917 12.9766C16.1512 12.9766 16.0365 13.0912 16.0365 13.2317V13.9749L15.3932 13.6015C15.2711 13.5312 15.1121 13.5719 15.0419 13.6939C14.9716 13.8159 15.0123 13.9749 15.1343 14.0452L15.7814 14.4223L15.1343 14.7995C15.0123 14.8697 14.9679 15.0287 15.0419 15.1508Z"
        fill="#FFCFBB"
      />
    </svg>
  );
};

const MarkettingIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.7139 7.09901L9.7493 1.13437C9.13269 0.517728 8.12927 0.517693 7.51259 1.13437C6.95825 1.68868 6.91051 2.53408 7.31987 3.13775L7.31157 3.17927C6.88154 5.3296 5.83462 7.28583 4.28392 8.8365L1.5481 11.5723C0.929983 12.1905 0.929878 13.1909 1.5481 13.809L3.03921 15.3002C3.65729 15.9183 4.65777 15.9183 5.27592 15.3002L5.64872 14.9274L8.25822 17.5369C8.87634 18.155 9.87674 18.1551 10.4949 17.5369C11.1116 16.9202 11.1116 15.9168 10.4949 15.3002L9.37654 14.1818L9.74933 13.809C10.3674 13.191 10.3675 12.1906 9.74933 11.5724L9.496 11.319C10.7422 10.4465 12.1576 9.83899 13.6691 9.53668L13.7111 9.52827C14.3282 9.94491 15.1716 9.87794 15.7139 9.33565H15.714C16.3305 8.71905 16.3305 7.71569 15.7139 7.09901ZM4.53036 14.5546C4.32435 14.7606 3.99079 14.7606 3.78477 14.5546L2.29366 13.0634C2.08761 12.8574 2.08761 12.5239 2.29366 12.3179L4.90312 9.70838L7.13983 11.9451C6.88453 12.2004 4.79196 14.293 4.53036 14.5546ZM9.7493 16.0457C9.95482 16.2512 9.95482 16.5857 9.7493 16.7913C9.54378 16.9968 9.20926 16.9968 9.00374 16.7913L6.39424 14.1818L7.13983 13.4362L9.7493 16.0457ZM7.88539 12.6906C8.04387 12.5322 8.28111 12.2894 8.65552 11.9696L9.00374 12.3179C9.20979 12.5239 9.20979 12.8574 9.00374 13.0634L8.63095 13.4362L7.88539 12.6906ZM7.90778 11.222L5.62622 8.94039C6.84891 7.52855 7.72451 5.86197 8.19297 4.05142L12.7967 8.6552C10.9862 9.12363 9.31965 9.99923 7.90778 11.222ZM14.9683 8.59006C14.7622 8.79607 14.4288 8.79607 14.2227 8.59006L8.25815 2.62549C8.0521 2.4194 8.0521 2.08598 8.25815 1.87993C8.4642 1.67388 8.79769 1.67388 9.00374 1.87993L14.9683 7.84447C15.1738 8.05002 15.1738 8.38447 14.9683 8.59006Z"
        fill="#FFCFBB"
      />
      <path
        d="M5.2759 11.5724C5.07006 11.3665 4.73622 11.3665 4.53034 11.5724L3.78478 12.3179C3.5789 12.5238 3.5789 12.8576 3.78478 13.0635C3.99062 13.2694 4.3245 13.2694 4.53034 13.0635L5.2759 12.3179C5.48178 12.1121 5.48178 11.7782 5.2759 11.5724Z"
        fill="#FFCFBB"
      />
      <path
        d="M12.1708 0C11.8796 0 11.6436 0.236039 11.6436 0.527202V1.58161C11.6436 1.87277 11.8796 2.10881 12.1708 2.10881C12.4619 2.10881 12.698 1.87277 12.698 1.58161V0.527202C12.698 0.236039 12.4619 0 12.1708 0Z"
        fill="#FFCFBB"
      />
      <path
        d="M16.3882 4.2168H15.3338C15.0427 4.2168 14.8066 4.45284 14.8066 4.744C14.8066 5.03516 15.0427 5.2712 15.3338 5.2712H16.3882C16.6794 5.2712 16.9154 5.03516 16.9154 4.744C16.9154 4.45284 16.6794 4.2168 16.3882 4.2168Z"
        fill="#FFCFBB"
      />
      <path
        d="M15.7063 1.20909C15.5005 1.00322 15.1666 1.00322 14.9608 1.20909L13.9064 2.2635C13.7005 2.46937 13.7005 2.80318 13.9064 3.00905C14.1122 3.21493 14.446 3.21496 14.6519 3.00905L15.7063 1.95465C15.9122 1.74878 15.9122 1.415 15.7063 1.20909Z"
        fill="#FFCFBB"
      />
    </svg>
  );
};

const cardIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="22.8857" height="17" stroke="#FFCFBB" />
      <rect y="3.08594" width="23.8857" height="4.62857" fill="#FFCFBB" />
    </svg>
  );
}

const PromotionsIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_320_31698)">
        <path
          d="M16.7077 9.29879C16.5896 9.11724 16.5896 8.88275 16.7077 8.70121L17.3651 7.69082C17.9638 6.7705 17.5604 5.53407 16.537 5.14232L15.4113 4.71131C15.209 4.63383 15.0711 4.44409 15.06 4.22777L14.998 3.02403C14.9414 1.92772 13.8883 1.16421 12.83 1.44897L11.666 1.76193C11.4569 1.81811 11.2338 1.74565 11.0977 1.57722L10.3399 0.639783C9.64971 -0.213946 8.34915 -0.212575 7.66016 0.639783L6.90234 1.57725C6.76622 1.74572 6.54315 1.81811 6.33397 1.76196L5.16992 1.449C4.10951 1.16382 3.05834 1.92987 3.00195 3.02407L2.9399 4.22781C2.92872 4.44409 2.79088 4.63386 2.58862 4.71131L1.463 5.14232C0.437459 5.53488 0.0372429 6.77233 0.634861 7.69086L1.29224 8.70121C1.41033 8.88272 1.41033 9.11728 1.29224 9.29879L0.634966 10.3091C0.0361179 11.2296 0.439709 12.466 1.46303 12.8577L2.58873 13.2887C2.79098 13.3662 2.92886 13.5559 2.94001 13.7722L3.00206 14.976C3.05859 16.0725 4.11186 16.8357 5.17003 16.551L6.33401 16.2381C6.54322 16.182 6.76625 16.2543 6.90241 16.4228L7.6602 17.3602C8.35049 18.2141 9.65102 18.2124 10.3399 17.3602L11.0977 16.4228C11.2338 16.2544 11.457 16.182 11.6661 16.2381L12.8301 16.551C13.8902 16.8363 14.9416 16.0703 14.9981 14.976L15.0601 13.7722C15.0713 13.5559 15.2092 13.3662 15.4114 13.2887L16.537 12.8577C17.5625 12.4652 17.9627 11.2277 17.3652 10.3091L16.7077 9.29879ZM16.1169 11.7604L14.9912 12.1914C14.3552 12.4349 13.9217 13.0317 13.8867 13.7117L13.8246 14.9154C13.8066 15.2642 13.4718 15.5068 13.1351 15.4164L11.9711 15.1034C11.3135 14.9265 10.6119 15.1546 10.1839 15.6841L9.42616 16.6215C9.20661 16.8931 8.79303 16.8925 8.5739 16.6215L7.81619 15.6841C7.48438 15.2736 6.98826 15.0443 6.47562 15.0443C6.32694 15.0443 6.17682 15.0636 6.02892 15.1034L4.86487 15.4164C4.52751 15.5069 4.19339 15.2635 4.17539 14.9154L4.11334 13.7117C4.07829 13.0317 3.64471 12.4349 3.00881 12.1914L1.88311 11.7604C1.55697 11.6355 1.42974 11.242 1.61979 10.9499L2.27714 9.93958C2.64849 9.36878 2.64849 8.63114 2.27714 8.06042L1.61979 7.05007C1.42932 6.75736 1.55764 6.36421 1.88315 6.23958L3.00884 5.80857C3.64478 5.56507 4.07832 4.96834 4.11338 4.28831L4.17543 3.08457C4.19339 2.73579 4.52825 2.49321 4.86491 2.58363L6.02896 2.89659C6.68655 3.07346 7.38809 2.84544 7.81615 2.31588L8.57394 1.37845C8.79349 1.1069 9.2071 1.10746 9.42616 1.37845L10.1839 2.31592C10.6121 2.84547 11.3135 3.0735 11.9711 2.89659L13.1352 2.58363C13.4725 2.49303 13.8067 2.73649 13.8247 3.08457L13.8867 4.28831C13.9217 4.96834 14.3553 5.56511 14.9912 5.80857L16.1169 6.23961C16.443 6.36442 16.5703 6.75795 16.3802 7.05007L15.7229 8.06038C15.3515 8.63114 15.3515 9.36878 15.7229 9.93958L16.3802 10.9499C16.5706 11.2427 16.4424 11.6358 16.1169 11.7604Z"
          fill="#FFCFBB"
        />
        <path
          d="M11.9347 6.00603C11.7053 5.77664 11.3333 5.77664 11.1039 6.00603L5.62077 11.4892C5.39138 11.7186 5.39138 12.0906 5.62081 12.32C5.73552 12.4347 5.88588 12.4921 6.03621 12.4921C6.18654 12.4921 6.33693 12.4347 6.45161 12.32L11.9348 6.8368C12.1642 6.60745 12.1642 6.23546 11.9347 6.00603Z"
          fill="#FFCFBB"
        />
        <path
          d="M6.62417 5.83398C5.97628 5.83398 5.44922 6.36108 5.44922 7.00893C5.44922 7.65683 5.97635 8.18389 6.62417 8.18389C7.27206 8.18389 7.79912 7.65679 7.79912 7.00893C7.79915 6.36108 7.27206 5.83398 6.62417 5.83398Z"
          fill="#FFCFBB"
        />
        <path
          d="M10.9318 10.1426C10.2839 10.1426 9.75684 10.6697 9.75684 11.3175C9.75684 11.9654 10.2839 12.4925 10.9318 12.4925C11.5796 12.4925 12.1067 11.9654 12.1067 11.3175C12.1068 10.6697 11.5797 10.1426 10.9318 10.1426Z"
          fill="#FFCFBB"
        />
      </g>
      <defs>
        <clipPath id="clip0_320_31698">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const TechIcon = () => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.511363 10.3233L1.70619 10.5191C1.89496 11.434 2.25622 12.3046 2.77066 13.0844L2.0631 14.0719C1.91628 14.2718 1.91881 14.5445 2.06931 14.7416C2.24772 14.9597 2.4373 15.1684 2.63725 15.367C2.83896 15.569 3.0469 15.7552 3.26105 15.9352C3.45829 16.086 3.7314 16.0885 3.9314 15.9414L4.91829 15.2335C5.69731 15.7483 6.56731 16.1098 7.48173 16.2986L7.67726 17.4944C7.7145 17.739 7.90967 17.9291 8.15518 17.9599C8.32524 17.9791 8.49656 17.9909 8.6716 17.9996C8.7566 18.0038 8.83962 17.9731 8.90146 17.9146C8.9633 17.8562 8.99865 17.775 8.99931 17.6899V15.2028C8.99841 15.0352 8.86524 14.8981 8.69767 14.8925C5.5615 14.7299 3.10201 12.1396 3.10201 8.99922C3.10201 5.85884 5.5615 3.26855 8.69767 3.10597C8.86524 3.10029 8.99841 2.9633 8.99931 2.79562V0.310693C8.99889 0.225633 8.96378 0.144418 8.90209 0.0858199C8.8404 0.0272214 8.75747 -0.00362467 8.6725 0.000339968C8.49809 0.00757843 8.32565 0.0198027 8.15515 0.0369528C7.90958 0.0704119 7.71519 0.261285 7.67723 0.506191L7.4817 1.70195C6.56731 1.89108 5.69734 2.25264 4.91826 2.76735L3.93137 2.05916C3.73137 1.91201 3.45826 1.91454 3.26102 2.06537C3.04353 2.24402 2.83533 2.43369 2.63722 2.63361C2.43577 2.8307 2.24613 3.0395 2.06928 3.25894C1.91815 3.4563 1.91562 3.72977 2.06307 3.92989L2.77063 4.91742C2.25631 5.69692 1.89505 6.56719 1.70616 7.48178L0.511333 7.67731C0.266667 7.71468 0.0765745 7.90997 0.0458185 8.15556C-0.0152729 8.7125 -0.0152729 9.27446 0.0458185 9.8314C0.0734208 10.0811 0.263573 10.282 0.511363 10.3233Z"
        fill="#FFCFBB"
      />
      <path
        d="M8.70265 4.35376C6.25086 4.50907 4.3418 6.5429 4.3418 8.99959C4.3418 11.4563 6.25089 13.4901 8.70265 13.6454C8.78066 13.6487 8.85658 13.6197 8.91266 13.5654C8.96874 13.5111 9.00006 13.4361 8.99934 13.358V4.64114C9.00009 4.56305 8.96877 4.48811 8.91266 4.43378C8.85658 4.37944 8.78066 4.35052 8.70265 4.35376Z"
        fill="#FFCFBB"
      />
      <path
        d="M11.1718 4.6555H9.62012V5.27617H11.1718C11.6854 5.27464 12.1013 4.85872 12.1028 4.34514V2.42599C12.5304 2.27485 12.7868 1.83769 12.7101 1.39077C12.6334 0.943849 12.246 0.617188 11.7925 0.617188C11.3391 0.617188 10.9515 0.943849 10.8749 1.39077C10.7982 1.83769 11.0546 2.27485 11.4821 2.42599V4.34514C11.4821 4.51656 11.3432 4.6555 11.1718 4.6555Z"
        fill="#FFCFBB"
      />
      <path
        d="M9.62012 6.51524H12.7236C12.895 6.51524 13.0339 6.37629 13.0339 6.20488C13.0339 6.03347 12.895 5.89453 12.7236 5.89453H9.62012V6.51524Z"
        fill="#FFCFBB"
      />
      <path
        d="M9.62012 13.3453H11.1718C11.3432 13.3453 11.4822 13.4842 11.4822 13.6556V15.5748C11.0547 15.7259 10.7982 16.1631 10.8749 16.61C10.9516 17.0569 11.3391 17.3836 11.7925 17.3836C12.246 17.3836 12.6335 17.0569 12.7102 16.61C12.7868 16.1631 12.5304 15.7259 12.1029 15.5748V13.6556C12.1013 13.1421 11.6854 12.7261 11.1719 12.7246H9.62015V13.3453H9.62012Z"
        fill="#FFCFBB"
      />
      <path
        d="M14.2753 10.2422H9.62012V10.8629H14.2753C14.4467 10.8629 14.5856 11.0018 14.5856 11.1732V12.782C14.1581 12.9332 13.9017 13.3703 13.9783 13.8173C14.055 14.2642 14.4425 14.5909 14.896 14.5909C15.3494 14.5909 15.7369 14.2642 15.8136 13.8173C15.8903 13.3703 15.6338 12.9332 15.2063 12.782V11.1732C15.2048 10.6596 14.7888 10.2437 14.2753 10.2422Z"
        fill="#FFCFBB"
      />
      <path
        d="M17.3787 8.06836C16.9856 8.06998 16.6358 8.31837 16.5048 8.68904H9.62012V9.30971H16.5048C16.6633 9.75492 17.1308 10.0103 17.5911 9.90309C18.0514 9.79592 18.358 9.36041 18.3037 8.89093C18.2493 8.42148 17.8513 8.06752 17.3787 8.06836Z"
        fill="#FFCFBB"
      />
      <path
        d="M13.0339 11.7928C13.0339 11.6214 12.895 11.4824 12.7236 11.4824H9.62012V12.1031H12.7236C12.895 12.1031 13.0339 11.9642 13.0339 11.7928Z"
        fill="#FFCFBB"
      />
      <path
        d="M15.2063 6.82779V5.21896C15.6338 5.06782 15.8903 4.63066 15.8136 4.18374C15.7369 3.73682 15.3494 3.41016 14.896 3.41016C14.4425 3.41016 14.055 3.73682 13.9783 4.18374C13.9017 4.63066 14.1581 5.06782 14.5856 5.21896V6.82779C14.5856 6.9992 14.4467 7.13814 14.2753 7.13814H9.62012V7.75882H14.2753C14.7889 7.75726 15.2048 7.34133 15.2063 6.82779Z"
        fill="#FFCFBB"
      />
    </svg>
  );
};

const WayaUserIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_320_31728)">
        <path
          d="M9.00022 9.02344C4.25672 9.02344 0.397461 12.8827 0.397461 17.6262C0.397461 17.8327 0.56504 18.0002 0.771506 18.0002H17.229C17.4354 18.0002 17.603 17.8327 17.603 17.6262C17.603 12.8827 13.7437 9.02344 9.00022 9.02344Z"
          fill="#FFCFBB"
        />
        <path
          d="M9.0001 8.22871C11.2724 8.22871 13.1145 6.38665 13.1145 4.11436C13.1145 1.84206 11.2724 0 9.0001 0C6.7278 0 4.88574 1.84206 4.88574 4.11436C4.88574 6.38665 6.7278 8.22871 9.0001 8.22871Z"
          fill="#FFCFBB"
        />
      </g>
      <defs>
        <clipPath id="clip0_320_31728">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const WayagramIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_320_31736)">
        <path
          d="M15.364 3.72586C13.6641 2.02602 11.404 1.08984 9 1.08984C6.59602 1.08984 4.33593 2.02602 2.63602 3.72586C0.936176 5.42577 0 7.68586 0 10.0898C0 11.3867 0.270527 12.6384 0.804059 13.8102C1.31896 14.9411 2.05031 15.9384 2.97784 16.7745C3.19416 16.9695 3.52765 16.9522 3.72263 16.7359C3.91764 16.5195 3.90034 16.1861 3.68399 15.9911C2.01301 14.4849 1.05469 12.334 1.05469 10.0898C1.05469 5.70878 4.61893 2.14453 9 2.14453C13.3811 2.14453 16.9453 5.70878 16.9453 10.0898C16.9453 12.334 15.987 14.4849 14.316 15.9911C14.0997 16.1861 14.0824 16.5195 14.2774 16.7359C14.4724 16.9522 14.8058 16.9695 15.0222 16.7745C15.9497 15.9385 16.681 14.9411 17.1959 13.8103C17.7295 12.6384 18 11.3867 18 10.0898C18 7.68586 17.0638 5.42577 15.364 3.72586Z"
          fill="#FFCFBB"
        />
        <path
          d="M10.9336 10.7578V9.35156C10.9336 8.28538 10.0662 7.41797 9 7.41797C7.93382 7.41797 7.06641 8.28538 7.06641 9.35156V10.7578C7.06641 11.824 7.93382 12.6914 9 12.6914C10.0662 12.6914 10.9336 11.824 10.9336 10.7578Z"
          fill="#FFCFBB"
        />
        <path
          d="M11.3295 12.627C10.7813 13.3089 9.94103 13.7466 9 13.7466C8.05897 13.7466 7.21867 13.3089 6.67051 12.627C5.65879 13.1062 4.95703 14.1367 4.95703 15.3286V16.3833C4.95703 16.6745 5.19314 16.9106 5.48438 16.9106H12.5156C12.8069 16.9106 13.043 16.6745 13.043 16.3833V15.3286C13.043 14.1367 12.3412 13.1062 11.3295 12.627Z"
          fill="#FFCFBB"
        />
        <path
          d="M9 5.30859C6.3636 5.30859 4.21875 7.45348 4.21875 10.0898C4.21875 11.002 4.47578 11.8739 4.94729 12.6232C5.18516 12.3589 5.45811 12.1249 5.7606 11.9293C5.44447 11.3765 5.27344 10.7464 5.27344 10.0898C5.27344 8.03503 6.94515 6.36328 9 6.36328C11.0548 6.36328 12.7266 8.03503 12.7266 10.0898C12.7266 10.7464 12.5555 11.3765 12.2394 11.9293C12.5419 12.1249 12.8149 12.3589 13.0527 12.6232C13.5242 11.8738 13.7812 11.002 13.7812 10.0898C13.7812 7.45348 11.6364 5.30859 9 5.30859Z"
          fill="#FFCFBB"
        />
        <path
          d="M9 3.19922C5.20049 3.19922 2.10938 6.29033 2.10938 10.0898C2.10938 11.8464 2.77597 13.5082 3.9426 14.7679C4.00243 14.346 4.1284 13.9403 4.31198 13.5643C3.57606 12.5727 3.16406 11.3605 3.16406 10.0898C3.16406 6.87192 5.78204 4.25391 9 4.25391C12.218 4.25391 14.8359 6.87192 14.8359 10.0898C14.8359 11.3605 14.4239 12.5727 13.688 13.5643C13.8716 13.9403 13.9975 14.346 14.0574 14.7679C15.224 13.5082 15.8906 11.8464 15.8906 10.0898C15.8906 6.29033 12.7995 3.19922 9 3.19922Z"
          fill="#FFCFBB"
        />
      </g>
      <defs>
        <clipPath id="clip0_320_31736">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const KycIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1032_13846)">
        <path
          d="M9.917 3.65967C9.917 5.67649 8.28196 7.31137 6.26514 7.31137C4.24832 7.31137 2.61328 5.67649 2.61328 3.65967C2.61328 1.64269 4.24832 0.0078125 6.26514 0.0078125C8.28196 0.0078125 9.917 1.64269 9.917 3.65967Z"
          fill="#FFCFBB"
        />
        <path
          d="M10.2924 11.1529C9.18078 10.206 7.76864 9.69141 6.27416 9.69141H6.26194C4.56981 9.69559 2.99299 10.3543 1.82786 11.5482C0.708082 12.7009 0.0617542 14.253 0 15.9533L10.737 15.9327C9.53587 14.6184 9.35431 12.6662 10.2924 11.1529Z"
          fill="#FFCFBB"
        />
        <path
          d="M17.853 17.2425L16.2226 15.5423C17.1677 14.5022 17.3801 12.9897 16.7578 11.7295C16.1356 10.4693 14.8056 9.71832 13.4052 9.83636C12.0048 9.9544 10.8193 10.9175 10.4168 12.2641C10.0144 13.6104 10.4769 15.0662 11.5828 15.9335H11.6074V15.954C12.7687 16.8509 14.3732 16.9056 15.5927 16.0898L17.326 17.8766C17.3994 17.9389 17.493 17.9725 17.5894 17.9713C17.7119 17.972 17.8283 17.9176 17.9063 17.8231C17.9765 17.7391 18.0101 17.6306 18.0001 17.5217C17.99 17.4128 17.9371 17.3123 17.853 17.2425ZM13.6907 15.7852C12.2883 15.7886 11.1491 14.6541 11.1464 13.252C11.1438 11.8496 12.2789 10.7109 13.681 10.709C15.0834 10.707 16.2215 11.8427 16.2226 13.2451C16.2289 13.9192 15.9643 14.5676 15.4885 15.0451C15.0124 15.5227 14.3648 15.7892 13.6907 15.7852Z"
          fill="#FFCFBB"
        />
      </g>
      <defs>
        <clipPath id="clip0_1032_13846">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
const UserFeaturesIcon = () => {
  return (
    <svg
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.875 0L0 4.5V13.5L7.875 18L15.7477 13.5013L15.75 13.4977V4.5L7.875 0ZM7.875 1.73227L13.4752 4.932L11.9605 5.7978L7.875 3.46432L3.79035 5.79847L2.2743 4.932L7.875 1.73227ZM11.2039 7.09785V10.0361L8.63302 8.568V5.6295L11.2039 7.09785ZM7.11697 5.6295V8.56732L4.5468 10.0359V7.09785L7.11697 5.6295ZM7.11697 15.8348L1.51538 12.6342V6.2307L3.03052 7.0965V11.7677L7.11697 14.103V15.8348ZM5.30347 11.3348L7.87433 9.8658L10.4458 11.3348L7.875 12.8034L5.30347 11.3348ZM14.2346 12.6342L8.63302 15.8348V14.103L12.7192 11.7686V7.0965L14.2344 6.2307V12.6342H14.2346Z"
        fill="#FFCFBB"
      />
    </svg>
  );
};
const LogOut = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 18H7C5.89543 18 5 17.1046 5 16V12H7V16H16V2H7V6H5V2C5 0.89543 5.89543 0 7 0H16C17.1046 0 18 0.89543 18 2V16C18 17.1046 17.1046 18 16 18ZM9 13V10H0V8H9V5L14 9L9 13Z"
        fill="#FF0505"
      />
    </svg>
  );
};

const ContentIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_320_31751)">
        <path
          d="M14.6471 5.37653H8.15294L6.86118 3.84124C6.81772 3.789 6.7526 3.75971 6.68471 3.76183H1.44529C0.645353 3.76765 0 4.41777 0 5.21771V14.6606C0.000970588 15.4633 0.651441 16.1138 1.45412 16.1148H14.6471C15.4497 16.1138 16.1002 15.4633 16.1012 14.6606V6.83065C16.1002 6.02797 15.4497 5.3775 14.6471 5.37653Z"
          fill="#FFCFBB"
        />
        <path
          d="M16.555 3.49567H10.0592L8.76739 1.96038C8.72394 1.90814 8.65882 1.87885 8.59092 1.88097H3.35327C2.62745 1.88216 2.01369 2.41836 1.91504 3.13744H6.6921C6.9426 3.13682 7.18044 3.24738 7.34151 3.4392L8.44445 4.75038H14.6474C15.7947 4.75232 16.7243 5.68192 16.7262 6.8292V14.2198C17.4536 14.129 17.9998 13.5111 18.0003 12.778V4.94803C17.9984 4.14945 17.3536 3.5015 16.555 3.49567Z"
          fill="#FFCFBB"
        />
      </g>
      <defs>
        <clipPath id="clip0_320_31751">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export {
  OverviewIcon,
  UsersIcon,
  TransactionsIcon,
  SettingsIcon,
  LogsIcon,
  QrCodeIcon,
  OtpIcon,
  MarkettingIcon,
  PromotionsIcon,
  TechIcon,
  WayaUserIcon,
  WayagramIcon,
  UserFeaturesIcon,
  ContentIcon,
  KycIcon,
  LogOut,
  cardIcon,
};
